var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-popover',_vm._g(_vm._b({attrs:{"trigger":"hover","popper-class":"phone-share","width":150}},'el-popover',_vm.$attrs,false),_vm.$listeners),[_c('template',{slot:"reference"}),_vm._t("default",null,{"slot":"reference"}),_c('div',[_c('canvas',{ref:"qrCode"}),_c('div',{staticClass:"share-name"},[_vm._v("手机浏览器扫一扫 快速便捷访问")])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }